import React, { Fragment, useState, useEffect } from 'react';
import { Table, Panel, GateKeeper, LazyBoi, Grid, Modal, Button } from '@components'
import assetController, { Status } from '@app/App.Controller'
import { ReactComponent as Refresh } from '@assets/Icon_Refresh.svg';
import { ReactComponent as Info } from "@assets/Icon_Info_Large.svg"
import { Asset, Pool } from '@archetypes'
import styled from "styled-components"
import { parsePoolWeight, fromWei, calculateAPY } from "@util/helpers"
import useModal from "../../hooks/useModal"


const PoolItem = styled(
    ({ className, pool, apy }) => {

        const { open, openModal, closeModal } = useModal()

        const resolvePoolName = (pool) => {
            
            if (pool?.name === "PX-PERL-pxGOLD_MAR2022") {
                return "PX-pxGOLD-pxUSD (MAR2022)"
            } else if (pool?.name === "PX-PERL-pxUSD_MAR2022") {
                return "PX-pxUSD_MAR2022-USDC"
            }
            return pool?.name
        }

        return (
            <>
                <Panel className={className} fadeIn>
                    <Info onClick={openModal} className="icon-info" />
                    <div className="brand">
                        <Asset.Icon.ExtraLarge
                            token={[pool?.token0?.symbol, pool?.token1?.symbol]} 
                            text={pool?.token1?.symbol}
                        />
                        <h4>{resolvePoolName(pool)}</h4>
                        <p>{parsePoolWeight(pool)}</p>
                    </div>
                    <Panel.Divider small light noMargin={true} />
                    <div className="stat" >
                        {/* <div>
                            <h4>APY</h4>
                            <p>{apy.toLocaleString()}%</p>
                        </div> */}
                        <div>
                            <h4>Depth</h4>
                            <p>${Number(fromWei(pool?.depth.toFixed(0))).toLocaleString()}</p>
                        </div>
                    </div>
                    <Panel.Divider small light noMargin={true} />
                    <div className="actions">
                        {(!pool?.stake) || (pool?.stake?.units === "0")
                            ?
                            (() => {
                                
                                if (pool.name === "PX-PERL-pxGOLD_MAR2022" || pool.name === "PX-PERL-pxUSD_MAR2022") {
                                    let balancerPoolAddress
                                    if (pool.name === "PX-PERL-pxUSD_MAR2022") {
                                        balancerPoolAddress = "0x3a0d62bca2f4062e8badfdc90701d1228487f741"
                                    }
                                    if (pool.name === "PX-PERL-pxGOLD_MAR2022") {
                                        balancerPoolAddress = "0xb8676e16353497c8e8a71f343baf9679c7897b2f"
                                    }
                                    return (
                                        <a target="_blank" href={`https://pools.balancer.exchange/#/pool/${balancerPoolAddress}`}>
                                            <Pool.Button.Full>Join Pool</Pool.Button.Full>
                                        </a>
                                    )   
                                }

                                return (
                                    <Pool.Button.Full to={`/stake/${pool?.address}`}>Join Pool</Pool.Button.Full>
                                )
                            })()
                            :
                            <div className="-actions-info">
                                <div>
                                    <h4>Your Share</h4>
                                    <LazyBoi.Percent value={pool?.stake?.share} />
                                </div>
                                <div>
                                    <Button className="-actions-button" to={`/stake/${pool?.address}`} small >Manage</Button>
                                </div>
                            </div>
                        }
                    </div>
                </Panel>
                {open ? (
                    <Modal.PoolInfo
                        close={closeModal}
                        pool={pool}
                    />
                ) : null}
            </>
        )
    })`
        
        display: flex;
        flex-direction: column;

        >.icon-info {
            width: 24px;
            height: 24px;
            fill: var(--panel--background--color, grey);
            cursor: pointer;
            align-self: flex-end;
        }

        >.brand {
            text-align: center;

            h4 {
                line-height: 24px;
                font-size: 18px;
                font-weight: 600;
                color: var(--color-white); 
                margin-top: 1rem;
                margin-bottom: 0px;
            }
            
            p {
                margin-top: 0.3rem;
                font-size: 12px;
                line-height: 18px;
                margin-bottom: 2rem;
                font-weight: 600;
                color: var(--color-label, lightblue);
            }

        }

        >.stat {
            display: flex;
            padding-top: 1rem;
            padding-bottom: 1rem;
            div {
                flex: 1;
                font-weight: 600;

                

                h4 {
                    font-size: 14px;
                    color: var(--color-label, lightblue);
                    margin: 0px;
                    line-height: 18px;
                }
                p {
                    font-size: 16px;
                    color: var(--color-white);
                    margin: 0px;
                    line-height: 30px;

                }
            }
        }

        >.actions {
            margin-top: 3rem; 
            font-size: 16px;
            font-weight: 600;

            >.-actions-info {
                display: flex;
                flex-direction: row;
                font-size: 14px;
                h4 {
                    font-size: 14px;
                    color: var(--color-label, lightblue);
                    margin: 0px;
                    line-height: 16px;
                    margin-bottom: 3px;
                }
                div {
                    flex: 1; 
                    font-weight: 600;
                    :last-child {
                        text-align: right;
                        
                    }
                }
            }

            .-actions-button {
                height: 100%;
            }

        }

        
    `


export default () => {
    const { perlinx } = assetController
    const [poolItems, setPoolItems] = useState([])

    useEffect(() => {
        const sub = perlinx.state.subscribe(`pools`, pools => setPoolItems(Object.values(pools)), true)
        return () => sub.unsubscribe()
    }, []) // eslint-disable-line


    return (
        <GateKeeper
            controllerAssertions={[
                {
                    controller: 'perlinx',
                    key: 'status',
                    assert: val => val === Status.READY,
                    onFail: <Panel><Refresh className='rotate' /> Fetching PerlinX Liquidity Pools</Panel>,
                }
            ]}
            assertions={[
                {
                    assert: () => poolItems.length > 0,
                    onFail: () => <Panel><Refresh className='rotate' /> Fetching PerlinX Liquidity Pools</Panel>,
                },
                {
                    assert: () => poolItems && poolItems.length > 0,
                    onFail: () => <Panel>No Pools Available</Panel>,
                },
            ]}
            dependencies={[poolItems]}

        >
            <Grid cols={3}>
                {poolItems && poolItems.map((pool, index) => {

                    const apy = calculateAPY(pool?.token1?.symbol)

                    return (
                        <PoolItem
                            key={index}
                            pool={pool}
                            apy={apy}
                        />
                    )
                })}
            </Grid>
        </GateKeeper>
    )


}